webpackJsonp([1],{

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_extension_dataTool__ = __webpack_require__("Gq5i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_extension_dataTool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_extension_dataTool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_map_js_world_js__ = __webpack_require__("9OQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_map_js_world_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_map_js_world_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      title: '强化学习方向学者关系图 | MAP',
      teachers: [],
      paginate: ['teach', 'school'],
      teachInfos: [],
      university: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.axios.get('http://gameai.njupt.edu.cn/scholar-api/get_all_teachers').then(function (response) {
      _this.teachers = response.data;
    });
    this.axios.get('http://gameai.njupt.edu.cn/scholar-api/map_data_bachelor').then(function (response) {
      var data = response.data;
      _this.university = data['mapData'];
    });
    // this.mountedAllData()
    this.mountedArea();
  },

  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.toLowerCase().replace(/\b[a-z]/g, function (c) {
        return c.toUpperCase();
      });
    }
  },
  methods: {
    handleClick: function handleClick(teacherName) {
      this.teacherName = teacherName;
      this.title = teacherName + '的关系网络图 | FORCE';
      this.mountedTeachInfos(teacherName);
      this.mountedData();
    },
    mapClick: function mapClick() {
      this.title = '强化学习方向学者关系图 | MAP';
      this.mountedArea();
    },
    allClick: function allClick() {
      this.title = '强化学习方向学者关系图 | FORCE';
      this.mountedAllData();
    },
    mountedData: function mountedData() {
      window.echarts.dispose(document.getElementById('main'));
      var myChart = window.echarts.init(document.getElementById('main'));
      myChart.showLoading();
      var teacherName = this.teacherName;
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.post('http://gameai.njupt.edu.cn/scholar-api/get_relations_data', { 'name': teacherName }).done(function (xml) {
        myChart.hideLoading();
        var graph = __WEBPACK_IMPORTED_MODULE_2_echarts_extension_dataTool___default.a.gexf.parse(xml);
        var categories = [];
        categories[0] = { 'name': '本人' };
        categories[1] = { 'name': teacherName + '的导师' };
        categories[2] = { 'name': teacherName + '的学生' };
        categories[3] = { 'name': teacherName + '的共同作者' };
        graph.nodes.forEach(function (node) {
          node.itemStyle = null;
          // node.symbolSize = 10
          node.value = Math.floor((node.symbolSize - 10) * 1000);
          node.category = node.attributes[0];
          // Use random x, y
          node.x = node.y = null;
          node.draggable = true;
        });
        var option = {
          title: {
            top: 'bottom',
            left: 'right'
          },
          tooltip: {},
          legend: [{
            // selectedMode: 'single',
            data: categories.map(function (a) {
              return a.name;
            })
          }],
          animation: false,
          series: [{
            type: 'graph',
            layout: 'force',
            data: graph.nodes,
            links: graph.links,
            categories: categories,
            roam: true,
            label: {
              normal: {
                position: 'right'
              }
            },
            force: {
              repulsion: 1000,
              edgeLength: [10, 200]
            }
          }]
        };
        myChart.setOption(option);
      }, 'xml');
    },
    mountedAllData: function mountedAllData() {
      window.echarts.dispose(document.getElementById('main'));
      var myChart = window.echarts.init(document.getElementById('main'));
      myChart.showLoading();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.get('http://gameai.njupt.edu.cn/scholar-api/index_graph', function (xml) {
        myChart.hideLoading();
        var graph = __WEBPACK_IMPORTED_MODULE_2_echarts_extension_dataTool___default.a.gexf.parse(xml);
        var categories = [];
        graph.nodes.forEach(function (node) {
          node.itemStyle = null;
          node.symbolSize /= 1.5;
          node.value = node.symbolSize;
          node.label = {
            normal: {
              show: node.symbolSize > 10
            }
          };
        });
        var option = {
          title: {
            top: 'bottom',
            left: 'right'
          },
          tooltip: {},
          legend: [{
            // selectedMode: 'single',
            data: categories.map(function (a) {
              return a.name;
            })
          }],
          animationDurationUpdate: 1500,
          animationEasingUpdate: 'quinticInOut',
          series: [{
            type: 'graph',
            layout: 'circular',
            circular: {
              rotateLabel: true
            },
            data: graph.nodes,
            links: graph.links,
            roam: true,
            label: {
              normal: {
                position: 'right',
                formatter: '{b}'
              }
            },
            focusNodeAdjacency: true,
            lineStyle: {
              normal: {
                color: 'source',
                curveness: 0.3
              }
            }
          }]
        };
        myChart.setOption(option);
      }, 'xml');
    },
    mountedArea: function mountedArea() {
      window.echarts.dispose(document.getElementById('main'));
      var myChart = window.echarts.init(document.getElementById('main'));
      var uploadedDataURL = 'http://gameai.njupt.edu.cn/scholar-api/map_data_bachelor';
      myChart.showLoading();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.getJSON(uploadedDataURL, function (linedata) {
        myChart.hideLoading();
        var latlong = linedata['latlong'];
        var mapData = linedata['mapData'];
        var max = -Infinity;
        var min = Infinity;
        mapData.forEach(function (itemOpt) {
          if (itemOpt.value > max) {
            max = itemOpt.value;
          }
          if (itemOpt.value < min) {
            min = itemOpt.value;
          }
        });
        var option = {
          backgroundColor: '#404a59',
          title: {
            text: '强化学习方向学者学校分布情况',
            left: 'center',
            top: 'top',
            textStyle: {
              color: '#fff'
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: function formatter(params) {
              var value = (params.value + '').split('.');
              value = value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + '.' + value[1];
              return params.seriesName + '<br/>' + params.name + ' : ' + value;
            }
          },
          visualMap: {
            show: false,
            min: 0,
            max: max,
            inRange: {
              symbolSize: [6, 60]
            }
          },
          geo: {
            name: '强化学习方向学者学校分布情况',
            type: 'map',
            map: 'world',
            roam: true,
            aspectScale: '0.75',
            // left: '0px'
            // layoutSize: '100%',
            label: {
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#323c48',
                borderColor: '#111'
              },
              emphasis: {
                areaColor: '#2a333d'
              }
            }
          },
          series: [{
            type: 'scatter',
            coordinateSystem: 'geo',
            data: mapData.map(function (itemOpt) {
              return {
                name: itemOpt.name,
                value: [latlong[itemOpt.code].longitude, latlong[itemOpt.code].latitude, itemOpt.value],
                label: {
                  emphasis: {
                    position: 'right',
                    show: true
                  }
                },
                itemStyle: {
                  normal: {
                    color: itemOpt.color
                  }
                }
              };
            })
          }]
        };
        if (option && (typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) === 'object') {
          myChart.setOption(option, true);
        }
      });
      console.log(myChart.getWidth());
    },
    mountedTeachInfos: function mountedTeachInfos(teacherName) {
      var _this2 = this;

      this.axios.post('http://gameai.njupt.edu.cn/scholar-api/scholar_profile', { name: teacherName }).then(function (response) {
        _this2.teachInfos = response.data;
      });
    }
  }
});

/***/ }),

/***/ "A+0L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530cb9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("mIWs");
function injectStyle (ssrContext) {
  __webpack_require__("A+0L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530cb9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_paginate__ = __webpack_require__("/OX2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_paginate__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import './assets/bootstrap-3.3.7-dist/css/bootstrap.min.css'
window.echarts = __webpack_require__("XLwt");
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_paginate___default.a);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__("gORT");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__["a" /* default */]
  }]
}));

/***/ }),

/***/ "aNqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"navbar navbar-default navbar-static-top navbar-inverse"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_vm._v("学者信息系统")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-default navbar-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.mapClick()}}},[_vm._v("\n      Map\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default navbar-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.allClick()}}},[_vm._v("\n      All\n    ")])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"list-group"},[_c('paginate',{ref:"paginator1",attrs:{"name":"teach","list":_vm.teachers,"per":15}},_vm._l((_vm.paginated('teach')),function(teacher){return _c('button',{staticClass:"list-group-item",attrs:{"type":"button"},on:{"click":function($event){_vm.handleClick(teacher.name)}}},[_vm._v("\n                "+_vm._s(teacher.name)+"\n              ")])}))],1),_vm._v(" "),_c('nav',{staticClass:"pages",attrs:{"aria-label":"Page navigation"}},[_c('paginate-links',{attrs:{"for":"teach","simple":{
                  prev: 'Back',
                  next: 'Next'
                },"classes":{
                  'ul': 'pager'
                }}}),_vm._v(" "),(_vm.$refs.paginator1)?_c('span',[_vm._v("\n              Viewing "+_vm._s(_vm.$refs.paginator1.pageItemsCount)+" results\n            ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading",attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"panel-body"},[(_vm.teachInfos.name)?_c('div',[_c('div',{staticClass:"list-group"},_vm._l((_vm.teachInfos),function(value,key){return (value)?_c('a',{staticClass:"list-group-item"},[_c('h4',{staticClass:"list-group-item-heading"},[_vm._v(_vm._s(_vm._f("capitalize")(key)))]),_vm._v(" "),_c('p',{staticClass:"list-group-item-text"},[_vm._v(_vm._s(value))])]):_vm._e()}))]):_c('div',[_c('paginate',{ref:"paginator",attrs:{"name":"school","list":_vm.university,"per":12}},[_c('ul',{staticClass:"list-group"},_vm._l((_vm.paginated('school')),function(value){return _c('li',{staticClass:"list-group-item"},[_c('span',{staticClass:"badge"},[_vm._v(_vm._s(value.value))]),_vm._v("\n                      "+_vm._s(value.name)+"\n                    ")])}))]),_vm._v(" "),_c('nav',{staticClass:"pages",attrs:{"aria-label":"Page navigation"}},[_c('paginate-links',{attrs:{"for":"school","simple":{
                        prev: 'Back',
                        next: 'Next'
                      },"classes":{
                        'ul': 'pager'
                      }}}),_vm._v(" "),(_vm.$refs.paginator)?_c('span',[_vm._v("\n                    Viewing "+_vm._s(_vm.$refs.paginator.pageItemsCount)+" results\n                  ")]):_vm._e()],1)],1)])]),_vm._v(" "),_vm._m(1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"navbar-form navbar-left"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Search"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"}},[_vm._v("Submit")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"panel-body"},[_c('div',{attrs:{"id":"main"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b71dbeb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("aNqK");
function injectStyle (ssrContext) {
  __webpack_require__("ro5j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b71dbeb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b71dbeb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mIWs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ro5j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mounted: function mounted() {
    console.log(window.echarts);
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8c56542a7d11b19c8ffb.js